import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 10px 20px 0 rgba(58, 58, 58, 0.1);
  background-color: ${({ theme }) => theme.palette.white};
  overflow: hidden;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    padding: 30px 15px 0 15px;
  }

  iframe {
    border-radius: 8px;
  }
`;

export const LabelWrapper = styled.div`
  letter-spacing: 1px;
  margin-bottom: 40px;
`;

export const SummaryWrapper = styled.div`
  display: flex;
`;

export const SummaryText = styled.div`
  margin-bottom: 35px;
`;
export const LocationName = styled.div`
  display: block;
  margin-bottom: 3px;
`;

export const MapWrapper = styled.div<{ fullScreen: boolean }>`
  width: 100%;
  position: relative;
  height: 433px;
  margin-bottom: 70px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-bottom: 0px;
  }
  ${({ fullScreen }) =>
    fullScreen &&
    `
  width: 100vw;
  position: fixed;
  height: 100vh;
  z-index: 10000;
  top:0;
  left:0;
  `}

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    width: 100vw;
    left: -15px;
  }
`;
